import { FC, useState } from 'react';
import {
	Button,
	Heading,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Text,
} from 'src/components/ui';
import { IGroup } from 'src/lib/schemas';
import { toastError } from 'src/services/toast';

export interface GroupDeleteModalProps {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: (data: IGroup) => void;
	data?: IGroup;
}

const GroupDeleteModal: FC<GroupDeleteModalProps> = ({
	isOpen,
	onClose,
	onConfirm,
	data,
}) => {
	const [isDeleting, setIsDeleting] = useState(false);

	if (!data) return null;

	const handleClose = () => {
		if (isDeleting) return;
		onClose();
	};

	const handleDelete = async () => {
		setIsDeleting(true);
		try {
			await onConfirm(data);
		} catch (error: any) {
			toastError(error);
		} finally {
			setIsDeleting(false);
			onClose();
		}
	};

	return (
		<Modal isOpen={isOpen} onClose={handleClose}>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>
					<Heading>Delete Group</Heading>
				</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<Text mb={2}>
						Are you sure you want to delete group &ldquo;{data.name}
						&rdquo;?
					</Text>
				</ModalBody>
				<ModalFooter>
					<Button variant="outline" onClick={handleClose}>
						Cancel
					</Button>
					<Button
						colorScheme="red"
						ml={4}
						onClick={handleDelete}
						isLoading={isDeleting}
						loadingText="Deleting..."
					>
						Delete
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};

export default GroupDeleteModal;
